import axios from 'axios';
import {backendHost} from '../../config';

export const getRole = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/roles`, {params});
};